@switch (billingAction()) {
  @case (BillingAction.NO_MERCHANT_CONFIGURED) {
    <span>{{ 'CHECKOUT.CONTACT_NOT_CONFIGURED' | translate }}</span>
    @if (editable) {
      <span class="span-text" (click)="openEditContactDialog()">
        <a>{{ 'CHECKOUT.ADD' | translate }}</a>
      </span>
    }
  }
  @case (BillingAction.NO_PAYMENT_CONFIGURED) {
    <span>{{ 'CHECKOUT.PAYMENT_NOT_CONFIGURED' | translate }}</span>
    @if (editable) {
      <span class="span-text" (click)="openEditPaymentDialog()">
        <a>{{ 'CHECKOUT.ADD' | translate }}</a>
      </span>
    }
  }
  @case (BillingAction.INVALID_PAYMENT) {
    <span>{{ 'CHECKOUT.INVALID_PAYMENT' | translate }}</span>
    @if (editable) {
      <span class="span-text" (click)="openEditPaymentDialog()">
        <a>{{ 'CHECKOUT.EDIT' | translate }}</a>
      </span>
    }
  }
}
